import { css } from "@emotion/react";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const containerStyles = (isVisible = true) => css`
  height: 100%;
  display: ${isVisible ? "block" : "none"};
  overflow: hidden;
  width: 100%;
`;
